export default __webpack_public_path__ + "static/media/badgeMoneyOut16.38dd5973.svg";